__turbopack_context__.v({
  "container": "Dashboard-module__lWGdXq__container",
  "counter": "Dashboard-module__lWGdXq__counter",
  "counterBar": "Dashboard-module__lWGdXq__counterBar",
  "counterLabel": "Dashboard-module__lWGdXq__counterLabel",
  "counterTotal": "Dashboard-module__lWGdXq__counterTotal",
  "counterValue": "Dashboard-module__lWGdXq__counterValue",
  "counters": "Dashboard-module__lWGdXq__counters",
  "dashboardRise": "Dashboard-module__lWGdXq__dashboardRise",
  "descriptionCard": "Dashboard-module__lWGdXq__descriptionCard",
  "empty": "Dashboard-module__lWGdXq__empty",
  "funnelBar": "Dashboard-module__lWGdXq__funnelBar",
  "grid": "Dashboard-module__lWGdXq__grid",
  "loader": "Dashboard-module__lWGdXq__loader",
  "section": "Dashboard-module__lWGdXq__section",
  "sectionHeader": "Dashboard-module__lWGdXq__sectionHeader",
  "sectionTitle": "Dashboard-module__lWGdXq__sectionTitle",
  "taskCard": "Dashboard-module__lWGdXq__taskCard",
  "taskCta": "Dashboard-module__lWGdXq__taskCta",
  "taskList": "Dashboard-module__lWGdXq__taskList",
  "taskMain": "Dashboard-module__lWGdXq__taskMain",
  "taskMark": "Dashboard-module__lWGdXq__taskMark",
  "taskTitle": "Dashboard-module__lWGdXq__taskTitle",
});
